import moment from 'moment';

/**
 * Day-level dispatch-window checks for the foreman job service's equipment list. Moved out of `ForemanJobService`
 * (Bug 32137) so the service does not grow; behaviour is unchanged. A missing or unparseable date counts as open.
 */
export function isOnOrBefore(
  value: Date | string | null | undefined,
  compareTo: Date
): boolean {
  const parsed = parseDateValue(value);
  return !parsed || parsed.isSameOrBefore(moment(compareTo), 'day');
}

export function isOnOrAfter(
  value: Date | string | null | undefined,
  compareTo: Date
): boolean {
  const parsed = parseDateValue(value);
  return !parsed || parsed.isSameOrAfter(moment(compareTo), 'day');
}

function parseDateValue(
  value: Date | string | null | undefined
): moment.Moment | null {
  if (!value) {
    return null;
  }

  const parsed = moment(value);
  return parsed.isValid() ? parsed : null;
}
